module.exports = __webpack_public_path__ + "img/Sedan_Back.4c935845.svg";